(function ($) {
  Drupal.behaviors.remediesSamplesFormatter = {
    attach: function (context) {
      var chatNowLink = $('.chat-now', context);

      chatNowLink.click(function () {
        lpMTagConfig.delegate.prechatWindow($);
      });
    }
  };
})(jQuery);
